export const salesReviewNavigationState = ({
  active = false,
  checks = [],
  isComplete = false,
  reviewMode = false,
}) => {
  const hasChecks = checks.length > 0;
  const saved = hasChecks
    ? checks.every(check => check?.saved === true)
    : Boolean(isComplete);

  if (active) return { icon: saved ? 'check' : 'pencil', state: 'active' };
  if (saved) return { icon: 'check', state: 'saved' };
  if (reviewMode && hasChecks) return { icon: 'pencil', state: 'pending' };

  return { icon: 'pencil', state: 'default' };
};
